import React from "react";

/**
 * MappingCard — Displays field mappings as a compact visual table.
 *
 * Props:
 *   data: {
 *     mappings: [{ source_label, destination_label, transformation }],
 *     approved: boolean
 *   }
 *   onProceed: optional callback — shown when mappings exist and not yet approved
 */
const MappingCard = ({ data, onProceed }) => {
  if (!data || !data.mappings || data.mappings.length === 0) return null;
  
  if (data.approved || !onProceed) return null;

  return (
    <div className="w-full flex justify-end my-2">
      <button
        onClick={onProceed}
        className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white text-[0.75rem] font-bold rounded-lg hover:bg-blue-700 transition active:scale-[0.97] shadow-sm"
      >
        Approve &amp; Build
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default MappingCard;
